exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".webcamvideo[data-v-399c1a06]{width:100%;height:auto}.text-small[data-v-399c1a06]{font-size:.7rem;opacity:.8}", ""]);

// exports
